import { Box, TextField, Typography } from '@mui/material'
import theme from '../../../theme/theme'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import StringArrayInput from '../../Common/StringArrayInput'

interface InsurancePreferencesProps {
    InsurancePreferences: Record<string, any>
    handleInsurancePreferenceChange: (id: string, value: any) => void
    isInsuranceSet: boolean
    errors?: any
    disabled?: boolean
}

const InsurancePreferences = ({
    InsurancePreferences,
    handleInsurancePreferenceChange,
    isInsuranceSet,
    errors,
    disabled,
}: InsurancePreferencesProps): JSX.Element => {
    const { t } = useTranslation()

    const handleInputChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            if (
                e.target.name === 'systemPolicyNumber' &&
                !/^[a-zA-Z0-9]*$/.test(e.target.value)
            ) {
                return
            }
            handleInsurancePreferenceChange(e.target.name, e.target.value)
        },
        [handleInsurancePreferenceChange],
    )

    const handleArrayChange = useCallback(
        (id: string, value: string[]) => {
            handleInsurancePreferenceChange(id, value)
        },
        [handleInsurancePreferenceChange],
    )
    return (
        <Box>
            <Typography
                variant="h6"
                component="h2"
                sx={{
                    fontSize: theme.typography.h6,
                    textWrap: 'nowrap',
                    marginBottom: '15px',
                }}
            >
                {t('insurancePreferences')}
            </Typography>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, 1fr)',
                    gap: '20px',
                    alignItems: 'flex-start',
                }}
            >
                <TextField
                    id="add-org-insurance-policyNumber"
                    name="systemPolicyNumber"
                    label={t('policyNumber') + (isInsuranceSet ? ' *' : '')}
                    variant="outlined"
                    type="text"
                    value={InsurancePreferences?.systemPolicyNumber}
                    onChange={handleInputChange}
                    fullWidth
                    error={!!errors?.systemPolicyNumber}
                    helperText={errors?.systemPolicyNumber}
                    disabled={disabled}
                />
                <StringArrayInput
                    id="primaryAssuredCompanyCode"
                    label={
                        t('primaryAssuredCompanyCode') +
                        (isInsuranceSet ? ' *' : '')
                    }
                    value={InsurancePreferences?.primaryAssuredCompanyCode}
                    onChange={(val) =>
                        handleArrayChange('primaryAssuredCompanyCode', val)
                    }
                    error={!!errors?.primaryAssuredCompanyCode}
                    helperText={errors?.primaryAssuredCompanyCode}
                    allowedCharacters={/^[a-zA-Z0-9]*$/}
                    disabled={disabled}
                />
            </Box>
        </Box>
    )
}

export default InsurancePreferences
